import script from "./addbeike.vue?vue&type=script&setup=true&lang=js"
export * from "./addbeike.vue?vue&type=script&setup=true&lang=js"

import "./addbeike.vue?vue&type=style&index=0&id=3e4e7162&lang=less&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3e4e7162"]])

export default __exports__